import React, { useContext, useState, useEffect, useRef } from 'react';
import { TemplateContext } from '../../layout';
import FormAccordions from './FormAccordions';
import FormClassic from './formClassic';
import axios from 'axios';

const form = () => {
	const [templateContext, setTemplateContext] = useContext(TemplateContext);
	const [reach, setReach] = useState();
	const formLabels = window.post_template?.checkout_v3_form.checkout_v3_formLabels;
	const formSections = window.post_template?.checkout_v3_form.checkout_v3_formHeadings;
	const formType = window.post_template?.checkout_v3_form?.checkout_v3_radio;

	const [backError, setBackError] = useState();
	const backErrorField = useRef(null);
	const autofillValues = window?.userData;

	const scrollIntoView = (element) => {
		if (element) {
			element.scrollIntoView({ behavior: 'smooth', block: 'center', inline: 'nearest' });
		}
	};

	const withReachLocal = window.post_template?.checkout_v3_reach?.checkout_v3_reach_toggle ? 'local' : null;
	const withReactGlobal = window.reach_global?.reach_global ? 'global' : null;
	const withReachVar = withReachLocal || withReactGlobal;

	const merchantId = window.general_settings?.merchant_id;
	const reachBase = `https://checkout.rch.io/v2.22/badge?MerchantId=${merchantId}&Locale=${window?.countryCode?.toUpperCase()}`;

	useEffect(() => {
		if (merchantId) {
			axios
				.get(reachBase)
				.then((response) => {
					const data = response.data;
					setReach(data);
					if (data.result === 'ERROR') {
						console.log(data.message);
					}
				})
				.catch((error) => {
					console.log(error);
				});
		}
	}, []);

	const initialValues = {
		email: autofillValues?.email ? autofillValues.email : '',
		first_name: autofillValues.first_name ? autofillValues.first_name : '',
		last_name: autofillValues.last_name ? autofillValues.last_name : '',
		address: autofillValues.address ? autofillValues.address : '',
		country: autofillValues.country ? autofillValues.country : window.countryCode.toUpperCase(),
		city: autofillValues.city ? autofillValues.city : '',
		state: autofillValues.state ? autofillValues.state : '',
		zip: autofillValues.zip ? autofillValues.zip : '',
		phone: autofillValues.phone ? autofillValues.phone : '',
		card_number: '',
		card_exp_month: '',
		card_exp_year: '',
		card_cvc: '',
		policy: false,
	};

	const cleanCheck =
		(window.isMobile == false && window.msg?.enable_clean_version_in_desktop) ||
		(window.isMobile == true && window.msg?.enable_clean_version_in_mobile);

	const directCheck = window.msg?.clean_checkout_if_direct_customer && window.directCheck;

	const enableCleanVersion = directCheck | cleanCheck;

	const handleFormSubmit = (formValues, templateContext) => {
		if (
			!templateContext.config?.warrantyState &&
			!templateContext.popupClicked &&
			templateContext.showPopup &&
			cleanCheck == false
		) {
			setTemplateContext((prevContext) => ({
				...prevContext,
				displayPopup: true,
				formValues: formValues,
				popupClicked: false,
			}));
		} else {
			submit(formValues, templateContext);
		}
	};

	useEffect(() => {
		if (backError) {
			scrollIntoView(backErrorField?.current);
		}
	}, [backError]);

	const handlePaypalSubmit = () => {
		const fields = window.productData;
		if (!templateContext.config?.warrantyState && templateContext.showPopup && cleanCheck == false) {
			setTemplateContext((prevContext) => ({
				...prevContext,
				displayPopup: true,
				paymentMethod: 'paypal',
				popupClicked: false,
			}));
		} else {
			const paypalData = {
				products: {
					currencyCode: fields?.currency_code,
					paypalMerchant: fields?.paypal_merchant,
					...templateContext?.config,
					warrantyType: window.productData?.select_warranty_type_cc,
					warrantyPriceCalculation: window.productData?.multiply_price_by_amount,
					postId: window.getPostId,
				},
				nextStep: fields?.next_page_on_success,
				upsell: fields?.paypal_upsell ? fields?.paypal_upsell_settings : null,
				thankYou: fields?.paypal_thank_you_page,
				return_to: window.location.href,
				affiliate: window.affiliate,
			};

			setTemplateContext({ ...templateContext, isLoading: true, paymentMethod: 'paypal' });
			setBackError(null);
			!templateContext.outOfStockMode &&
				axios
					.post('/wp-json/checkout/v1/order/paypal', paypalData)
					.then((response) => {
						const data = response.data;

						if (data.result === 'ERROR') {
							setTemplateContext({ ...templateContext, isLoading: false });
							setBackError(data.message);
							console.log(data.message);
						} else {
							window.location.href = data;
						}
					})
					.catch((error) => {
						console.log(error);
						setBackError(error);
						setTemplateContext({ ...templateContext, isLoading: false });
					});
		}
	};

	const submit = async (formData, templateContext) => {
		const fields = window.productData;
		const navigator = window.navigator;

		const browserData = {
			acceptHeader: 'application/json',
			colorDepth: screen.colorDepth,
			javaEnabled: navigator.javaEnabled(),
			javaScriptEnabled: true,
			language: navigator.language,
			screenHeight: screen.height,
			screenWidth: screen.width,
			timeZoneOffset: new Date().getTimezoneOffset().toString(),
			userAgent: navigator.userAgent,
		};
		const requestData = {
			data: formData,
			affiliate: window.affiliate,
			products: {
				...templateContext?.config,
				isWarrantySelected: templateContext?.config?.warrantyState,
				warrantyType: window.productData?.select_warranty_type_cc,
				warrantyPriceCalculation: window.productData?.multiply_price_by_amount,
				currencyCode: fields?.currency_code,
				postId: window.getPostId,
			},
			upsell_path: fields?.next_page_on_success,
			return_to: window.location.href,
			browserData: browserData,
			paypalMerchant: fields?.paypal_merchant,
		};

		// Check if set paypal is withreach
		let paypalHandler = '';

		if (fields?.paypal_merchant) {
			const paypalMerchant = fields.paypal_merchant.split(',');
			paypalHandler = paypalMerchant[0];
		}

		if (templateContext?.paymentMethod == 'paypal' && paypalHandler !== 'wr') {
			const paypalData = {
				products: {
					currencyCode: fields?.currency_code,
					paypalMerchant: fields?.paypal_merchant,
					...templateContext?.config,
					isWarrantySelected: templateContext?.config?.warrantyState,
					warrantyType: window.productData?.select_warranty_type_cc,
					warrantyPriceCalculation: window.productData?.multiply_price_by_amount,
					postId: window.getPostId,
				},
				nextStep: fields?.next_page_on_success,
				upsell: fields?.paypal_upsell ? fields?.paypal_upsell_settings : null,
				thankYou: fields?.paypal_thank_you_page,
				return_to: window.location.href,
				affiliate: window.affiliate,
			};

			setTemplateContext({ ...templateContext, isLoading: true });
			setBackError(null);
			!templateContext.outOfStockMode &&
				axios
					.post('/wp-json/checkout/v1/order/paypal', paypalData)
					.then((response) => {
						const data = response.data;

						if (data.result === 'ERROR') {
							setTemplateContext({ ...templateContext, isLoading: false });
							setBackError(data.message);
							console.log(data.message);
						} else {
							window.location.href = data;
						}
					})
					.catch((error) => {
						console.log(error);
						setBackError(error);
						setTemplateContext({ ...templateContext, isLoading: false });
					});
		} else {
			let url = '/wp-json/checkout/v1/order';

			if (paypalHandler == 'wr') {
				url = '/wp-json/checkout/v1/order/pp-wr';
			}

			setTemplateContext({ ...templateContext, isLoading: true });
			setBackError(null);
			!templateContext.outOfStockMode &&
				axios
					.post(url, requestData)
					.then((response) => {
						const data = response.data;
						if (data.result === 'ERROR') {
							setBackError(data.message);
							setTemplateContext({ ...templateContext, isLoading: false });
							console.log(data.message);
						} else if (data.result === 'SUCCESS') {
							// Successful payment
							window.location.href = templateContext?.config.nextStep + '?orderId=' + data.message.orderId;
						} else if (data.result === 'MERC_REDIRECT') {
							// 3DS Bank Auth
							const message = data.message;
							if (message && message.url) {
								window.location.href = message.url;
							} else if (message && message.script) {
								eval(message.script);
							}
						}
					})
					.catch((error) => {
						console.error(error);
						setBackError(error);
						setTemplateContext({ ...templateContext, isLoading: false });
					});
		}
	};

	useEffect(() => {
		if (templateContext.popupClicked) {
			handleFormSubmit(templateContext.formValues, templateContext);
		}
	}, [templateContext?.popupClicked]);

	return formType == 'form_paypal_express' ? (
		<>
			<FormClassic
				handleFormSubmit={handleFormSubmit}
				handlePaypalSubmit={handlePaypalSubmit}
				initialValues={initialValues}
				labels={formLabels}
				headings={formSections}
				cleanVersion={!!enableCleanVersion}
				formSubmited={templateContext?.isLoading}
				withReach={withReachVar}
				compliance={templateContext?.complianceMode}
				reachData={reach}
			/>
			{backError && (
				<div ref={backErrorField} className="error-back">
					{backError}
				</div>
			)}
		</>
	) : (
		<>
			<FormAccordions
				handleFormSubmit={handleFormSubmit}
				handlePaypalSubmit={handlePaypalSubmit}
				labels={formLabels}
				initialValues={initialValues}
				headings={formSections}
				cleanVersion={!!enableCleanVersion}
				formSubmited={templateContext?.isLoading}
				withReach={withReachVar}
				reachData={reach}
			/>
			{backError && (
				<div ref={backErrorField} className="error-back">
					{backError}
				</div>
			)}
		</>
	);
};

export default form;
